import i18n from '../../../translations/i18n';

export const ROLE: Record<number, string> = {
  1: i18n.t('CounselingManagement.counselor'),
  2: i18n.t('CounselingManagement.observer'),
};

const CounselingTextBox = (params: any) => {
  return (
    <div className="flex items-center h-full w-full">
      <div className="w-full flex items-center h-4/5 border-[2px] border-solid border-[#B3B3B3] px-2 rounded-[4px]">
        {ROLE[params.value]}
      </div>
    </div>
  );
};

export default CounselingTextBox;
